import { useState, useEffect } from "react";
import { FaArrowUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // show button after user scrolls down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="
        btn
        btn-primary
        rounded-circle
        shadow-lg
        position-fixed
        d-flex
        align-items-center
        justify-content-center
        z-3
      "
      style={{
        width: "50px",
        height: "50px",
        right: "24px",
        bottom: "24px",
      }}
      aria-label="Scroll to top"
    >
      <FaArrowUp size={24} className="fs-5" />
    </button>
  );
};

export default ScrollToTopButton;
